import { render, staticRenderFns } from "./TextNotesExportButton.vue?vue&type=template&id=6213ddb6&"
import script from "./TextNotesExportButton.vue?vue&type=script&lang=js&"
export * from "./TextNotesExportButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports